/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Material Query Chart icon.
 * @export
 */

export const ICON_QUERY_CHART = (
  <svg fill="none" height="176" viewBox="0 0 173 176" width="173" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 86C0.5 38.5035 39.0035 0 86.5 0C133.996 0 172.5 38.5035 172.5 86V149.763C172.5 164.253 160.753 176 146.263 176H88.5C39.8989 176 0.5 136.601 0.5 88V86Z"
      fill="#F5F5F5"
    />
    <rect fill="#707070" height="100" rx="50" width="100" x="36.5" y="32" />
    <path
      d="M104.886 95.93C105.913 94.2967 106.52 92.4067 106.52 90.3533C106.52 84.5433 101.83 79.8533 96.0197 79.8533C90.2097 79.8533 85.5197 84.5433 85.5197 90.3533C85.5197 96.1633 90.2097 100.853 95.9963 100.853C98.0497 100.853 99.963 100.247 101.573 99.22L108.853 106.5L112.166 103.187L104.886 95.93ZM96.0197 96.1867C92.7997 96.1867 90.1863 93.5733 90.1863 90.3533C90.1863 87.1333 92.7997 84.52 96.0197 84.52C99.2397 84.52 101.853 87.1333 101.853 90.3533C101.853 93.5733 99.2397 96.1867 96.0197 96.1867ZM95.1797 76.3533C93.453 76.4 91.7963 76.7733 90.2797 77.4033L88.9963 75.4667L80.1297 89.8867L73.1063 81.6733L64.6363 95.23L60.833 92.5L72.4997 73.8333L79.4997 82L88.833 66.8333L95.1797 76.3533ZM101.223 77.52C99.7297 76.8667 98.1197 76.47 96.4397 76.3767L108.386 57.5L112.166 60.2533L101.223 77.52Z"
      fill="white"
    />
    <rect fill="#F5F5F5" height="56" rx="28" width="56" x="104.5" y="104" />
    <path
      clipRule="evenodd"
      d="M109.167 132C109.167 119.097 119.597 108.667 132.5 108.667C145.404 108.667 155.834 119.097 155.834 132C155.834 144.904 145.404 155.334 132.5 155.334C119.597 155.334 109.167 144.904 109.167 132ZM139.244 142.034C140.154 142.944 141.624 142.944 142.534 142.034C143.42 141.124 143.42 139.63 142.534 138.744L135.79 132L142.534 125.257C143.444 124.347 143.444 122.877 142.534 121.967C141.624 121.057 140.154 121.057 139.244 121.967L132.5 128.71L125.757 121.967C124.847 121.057 123.377 121.057 122.467 121.967C122.03 122.403 121.785 122.995 121.785 123.612C121.785 124.229 122.03 124.821 122.467 125.257L129.21 132L122.467 138.744C122.03 139.18 121.785 139.771 121.785 140.389C121.785 141.006 122.03 141.598 122.467 142.034C123.377 142.944 124.847 142.944 125.757 142.034L132.5 135.29L139.244 142.034Z"
      fill="#BABABA"
      fillRule="evenodd"
    />
  </svg>
);
